import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';

export function App() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-surface" />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}
